module.exports = __webpack_public_path__ + "assets/static/png/gerc.de7a2ee830f07a094e5841f8fb3f990b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/images/gerc.png
 ** module id = 535
 ** module chunks = 1
 **/